<div class="list-content" [hidden]="!propertyList">
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 px-3 pt-3" *ngFor="let property of propertyList; let i = index">
      <div class="list_card">
        <div
          class="row"
          role="button"
          [class.selected-card]="selectedProperty === property"
          (keydown.enter)="getDetails(property); $event.stopPropagation()"
          (click)="getDetails(property); $event.stopPropagation()"
          tabindex="10"
        >
          <div class="col-4 pr-0 proplist_imgWrap">
            <span style="color: transparent; position: absolute; top: 0">
              {{ property.Address }}
            </span>

            <img
              class="img-fluid mx-auto p-2 property-img"
              [src]="
                property.imgUrl
                  ? property.imgUrl
                  : listingImageBaseUrl + '?ListingId=' + (property.ListingId || 'null') + '&imageName=1&height=219'
              "
            />

            <!-- <ng-container *ngIf="property.ImageURLs">
              <img class="img-fluid mx-auto p-2" [src]="property.ImageURLs | normalizeImageUrl" />
            </ng-container>

            <ng-container *ngIf="!property.ImageURLs && property.isStreetViewAvailable !== false">
              <div class="p-md-3">
                <app-street-view
                  [defaultPlace]="property.defaultPlace"
                  [isMyHomeAccess]="true"
                  (streetViewAvailable)="onStreetViewAvailable($event)"
                  [containerHeight]="'120'"
                >
                </app-street-view>
              </div>
            </ng-container>
            <ng-container *ngIf="!property.ImageURLs && property.isStreetViewAvailable === false">
              <div class="p-md-3">
                <app-birds-eye-view [defaultPlace]="property.defaultPlace" [containerHeight]="'54'">
                </app-birds-eye-view>
              </div>
            </ng-container> -->
          </div>
          <div class="col-8 my-3 mx-0">
            <div class="col-lg-12 col-12 mt-1 pl-0">
              <h5 class="prop-address">
                {{ property.StreetAddress }}
                <br />
                <span class="sub-address"
                  >{{ property.City }}, {{ property.StateOrProvince }} {{ property.PostalCode }}
                </span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <mat-paginator
    *ngIf="reportsState.listPropertySetCount"
    class="my-4 pagination only-nav-buttons"
    [length]="reportsState.listPropertySetCount"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    hidePageSize="true"
    (page)="onPageChange($event)"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
